import React, { memo } from 'react';
import { Activity, AlertTriangle, TrendingUp, TrendingDown } from 'lucide-react';

// ============================================
// COMPACT ALERT ITEM
// ============================================
const AlertItem = memo(({ alert }) => {
  const isBuy = alert.side === 'BUY';
  const timestamp = new Date(alert.timestamp * 1000).toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <div 
      className={`px-2 py-1.5 border-l-2 ${isBuy ? 'border-buy bg-buy/5' : 'border-sell bg-sell/5'}`}
      data-testid={`alert-item-${alert.id}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          {isBuy ? (
            <TrendingUp className="w-3 h-3 text-buy" />
          ) : (
            <TrendingDown className="w-3 h-3 text-sell" />
          )}
          <span className={`font-mono text-[10px] font-semibold ${isBuy ? 'text-buy' : 'text-sell'}`}>
            {isBuy ? 'BUY' : 'SELL'}
          </span>
        </div>
        <span className="font-mono text-[9px] text-muted-foreground">
          {timestamp}
        </span>
      </div>
      <div className="flex items-center gap-2 mt-0.5 text-[9px] font-mono text-muted-foreground">
        <span>Vol: <span className="text-foreground">{(alert.volume/1000).toFixed(1)}K</span></span>
        <span>@{alert.price.toFixed(2)}</span>
      </div>
    </div>
  );
});

AlertItem.displayName = 'AlertItem';

// ============================================
// COMPACT ALERTS PANEL
// ============================================
export const AlertsPanel = memo(({ alerts }) => {
  return (
    <div className="flex flex-col h-full overflow-hidden" data-testid="alerts-panel">
      {/* Header */}
      <div className="flex items-center justify-between px-2 py-1 border-b border-border shrink-0">
        <div className="flex items-center gap-1.5">
          <AlertTriangle className="w-3 h-3 text-warning" />
          <span className="text-[10px] text-muted-foreground uppercase">Alerts</span>
        </div>
        <span className="font-mono text-[10px] text-muted-foreground">
          {alerts.length}
        </span>
      </div>
      
      {/* Scrollable Alert List */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        {alerts.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center p-2">
            <Activity className="w-4 h-4 mb-1 opacity-30 text-muted-foreground" />
            <p className="text-[10px] text-muted-foreground">
              No absorption alerts
            </p>
          </div>
        ) : (
          <div className="divide-y divide-border/30">
            {[...alerts].reverse().slice(0, 10).map((alert) => (
              <AlertItem key={alert.id} alert={alert} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

AlertsPanel.displayName = 'AlertsPanel';

export default AlertsPanel;
